import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d8776416"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "sdds-container-fluid",
  id: "main"
}
const _hoisted_2 = { class: "sdds-row" }
const _hoisted_3 = { class: "sdds-col-xxlg-6 sdds-col-xlg-6 sdds-col-lg-12 sdds-col-md-12 sdds-col-sm-12 sdds-col-xs-12" }
const _hoisted_4 = { class: "sdds-row row-tit-dat" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "File Upload History", -1))
const _hoisted_6 = { class: "right-in-row" }
const _hoisted_7 = { class: "div-date-picker" }
const _hoisted_8 = { class: "sdds-datetime-input-container" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Start date", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "datetime-icon icon-datetime-local icon-date" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M23.625 2.977a1 1 0 1 0-2 0v2.985l-11.344.01V2.99a1 1 0 1 0-2 0v2.985H6.25a4.2 4.2 0 0 0-4.2 4.2V25.77a4.2 4.2 0 0 0 4.2 4.2h19.54a4.2 4.2 0 0 0 4.2-4.2V10.167a4.2 4.2 0 0 0-4.191-4.2l-2.174-.004V2.977ZM4.05 10.174a2.2 2.2 0 0 1 2.2-2.2l16.376-.013 3.17.006a2.2 2.2 0 0 1 2.195 2.2v1.847H4.05l-.001-1.84Zm0 3.84V25.77a2.2 2.2 0 0 0 2.2 2.2h19.54a2.2 2.2 0 0 0 2.2-2.2V14.014H4.05Z",
      fill: "currentColor"
    })
  ])
], -1))
const _hoisted_11 = { class: "sdds-datetime-input-container" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "End date", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "datetime-icon icon-datetime-local icon-date" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M23.625 2.977a1 1 0 1 0-2 0v2.985l-11.344.01V2.99a1 1 0 1 0-2 0v2.985H6.25a4.2 4.2 0 0 0-4.2 4.2V25.77a4.2 4.2 0 0 0 4.2 4.2h19.54a4.2 4.2 0 0 0 4.2-4.2V10.167a4.2 4.2 0 0 0-4.191-4.2l-2.174-.004V2.977ZM4.05 10.174a2.2 2.2 0 0 1 2.2-2.2l16.376-.013 3.17.006a2.2 2.2 0 0 1 2.195 2.2v1.847H4.05l-.001-1.84Zm0 3.84V25.77a2.2 2.2 0 0 0 2.2 2.2h19.54a2.2 2.2 0 0 0 2.2-2.2V14.014H4.05Z",
      fill: "currentColor"
    })
  ])
], -1))
const _hoisted_14 = {
  key: 0,
  class: "spinner fa-4x center-in-row"
}
const _hoisted_15 = { class: "sdds-col-xxlg-6 sdds-col-xlg-6 sdds-col-lg-12 sdds-col-md-12 sdds-col-sm-12 sdds-col-xs-12" }
const _hoisted_16 = {
  key: 0,
  class: "sdds-row row-tit-details"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "File Details", -1))
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Download Data")
const _hoisted_19 = { class: "sdds-row" }
const _hoisted_20 = {
  key: 0,
  class: "spinner fa-4x center-in-row"
}

import { TypeImport } from '@/types/constants';
import { computed } from '@vue/reactivity';
import { ref, watch } from 'vue';
import Datepicker from 'vue3-datepicker';
import lsImport from '../services/lsImportServices';
import { useMainStore } from '../store/index';
import DownloadDataFile from './DownloadDataFile.vue';
import FileHistoryDetails from './FileHistoryDetails.vue';
import FileHistoryTable from './FileHistoryTable.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FileHistory',
  setup(__props) {

const date = new Date();

const fielsHistoryData = ref([]);
const fielsDetailsData = ref([]);
const importType = ref('');
const componentKey = ref(0);
const pickedStart = ref(new Date(date.getFullYear(), date.getMonth(), 1));
const pickedEnd = ref(new Date());
const loadingFileHistory = ref(false);
const loadingFileDetails = ref(false);

const userId = useMainStore().userId;

const getFileHistory = async () => {
  console.log('getFileHistory');
  const startDate = new Date(pickedStart.value.toDateString());
  startDate.setHours(0, 0, 0, 0);
  console.log(startDate);

  const endDate = new Date(pickedEnd.value.toDateString());
  endDate.setHours(23, 59, 59, 999);
  console.log(endDate);

  const from = startDate.toISOString().replace('.000Z', 'Z');
  const to = endDate.toISOString().replace('.999Z', 'Z');

  const request = {
    user: userId,
    from,
    to,
  };
  console.log('request: ', request);
  fielsHistoryData.value.length = 0;
  fielsDetailsData.value.length = 0;
  loadingFileHistory.value = true;
  lsImport.getFilesByUser(request)
    .then((response) => {
      // console.log('response-getFileHistory: ', response);
      const data = JSON.parse(response.data);
      fielsHistoryData.value.push(...data);
      componentKey.value += 1;
      loadingFileHistory.value = false;
    }).catch((error) => {
      console.log('error-getFileHistory: ', error);
      componentKey.value += 1;
      loadingFileHistory.value = false;
    });
};

const getFileDetails = ({ fileId, typeImport = '' }: any) => {
  importType.value = typeImport;
  const request = {
    fileId,
  };
  loadingFileDetails.value = true;
  lsImport.getFileDetails(request)
  .then((response) => {
    fielsDetailsData.value.length = 0;
    let data = JSON.parse(response.data);
    data.data.forEach(item => {
      if (item.additionalData && item.additionalData.length) {
        if(item.rowData?.customerName) item.additionalData = item.additionalData.filter(a => a.name !== "CustomerName");
      }
    });
    fielsDetailsData.value.push(...data.data);
    loadingFileDetails.value = false;
    }).catch((error) => {
      fielsDetailsData.value.length = 0;
      console.log('error-getFileDetails: ', error);
      loadingFileDetails.value = false;
    });
};

const sheetData = computed(() => {
  return fielsDetailsData.value.map(t => {
    const newObj = {
      ChassisNumber: t.rowData.chassisNumber,
      YntCustomerUrl: t?.additionalData?.find(a => a.name === "YntCustomerUrl")?.value,
      SalesRepFirstName:t.rowData.salesRepFirstName,
      SalesRepLastName:t.rowData.salesRepLastName,
      SalesRepEmail:t.rowData.salesRepEmail,
      CustomerName: t.rowData.customerName ?? t?.additionalData?.find(a => a.name === "CustomerName")?.value,
      MarketDenomination: t.additionalData?.find(a => a.name === "MarketDenomination")?.value,
    };

    const yntUrlForLine = t.additionalData?.find(a => a.name === "YntUrlForLine")?.value;
    if (yntUrlForLine) newObj['YntUrlForLine'] = yntUrlForLine;

    return newObj;
  });
});

getFileHistory();
watch([pickedStart, pickedEnd], getFileHistory);


return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_unref(Datepicker), {
                  class: "sdds-textfield-input sdds-textfield-input-date sdds-date-picker",
                  modelValue: pickedStart.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pickedStart).value = $event)),
                  upperLimit: pickedEnd.value,
                  "data-test-id": "pickerIni"
                }, null, 8, ["modelValue", "upperLimit"]),
                _hoisted_10
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(_unref(Datepicker), {
                  class: "sdds-textfield-input sdds-textfield-input-date sdds-date-picker",
                  modelValue: pickedEnd.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((pickedEnd).value = $event)),
                  lowerLimit: pickedStart.value,
                  "data-test-id": "pickerEnd"
                }, null, 8, ["modelValue", "lowerLimit"]),
                _hoisted_13
              ])
            ])
          ])
        ]),
        _createElementVNode("div", {
          class: "sdds-row",
          onDblclick: getFileHistory,
          "data-test-id": "tableData"
        }, [
          (loadingFileHistory.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "spinner",
                  class: "fa-spin"
                })
              ]))
            : _createCommentVNode("", true),
          (!loadingFileHistory.value)
            ? (_openBlock(), _createBlock(FileHistoryTable, {
                class: "table",
                key: componentKey.value,
                "file-data": fielsHistoryData.value,
                onShowDetailsRow: getFileDetails
              }, null, 8, ["file-data"]))
            : _createCommentVNode("", true)
        ], 32)
      ]),
      _createElementVNode("div", _hoisted_15, [
        (fielsDetailsData.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _hoisted_17,
              (importType.value === _unref(TypeImport).YNT || importType.value === _unref(TypeImport).YNT_MR)
                ? (_openBlock(), _createBlock(DownloadDataFile, {
                    key: 0,
                    "sheet-data": _unref(sheetData)
                  }, {
                    default: _withCtx(() => [
                      _hoisted_18
                    ]),
                    _: 1
                  }, 8, ["sheet-data"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_19, [
          (loadingFileDetails.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "spinner",
                  class: "fa-spin"
                })
              ]))
            : _createCommentVNode("", true),
          (!loadingFileDetails.value)
            ? (_openBlock(), _createBlock(FileHistoryDetails, {
                key: 1,
                class: "table",
                "file-data": fielsDetailsData.value
              }, null, 8, ["file-data"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})